import get from 'lodash.get';

const DEFAULT_NAME = 'NAME MISSING';

export const transform = (data) => {
  let names = [];
  let scores = [];
  let locales = [];
  let labeledScores = [];

  data.map(item => {
    const name = `${get(item, 'first_name', DEFAULT_NAME)} ${get(item, 'last_name', DEFAULT_NAME)}`;
    names.push(name);
    item.scores.map(({score, locale, labeledScore}) => {
      // Apply the same rounding logic as in dyslexia.js
      const integerPart = Math.floor(score);
      const roundedScore = integerPart === 29 ? Math.floor(score) : Math.round(score);
      scores.push(roundedScore);
      locales.push(locale);
      labeledScores.push(labeledScore);
    });
  });

  return { scores, names, locales, labeledScores };
}

export default { transform };